import { get_search_number } from "../common/functions/searches";
import {
  checkAll,
  changeMoneySelect,
  changeSelectOf,
  toggleDisplayOfLte,
  toggleDisplayOfGte,
  showCheckedItemName,
} from "../common/pages/search";

/* ---------------------------------------------------------
 PC検索系全体
--------------------------------------------------------- */
// NOTE: jQuery 3.x では $('selector').ready() がセレクタを無視して全ページで発火するため、
// $(function(){}) + 明示的なページガードに変更する
$(() => {
  if (
    !$(
      `body.pc.search, body.pc.users.index, body.pc.search_for_company, ${pc_404_selector}, ${pc_500_selector}, ${bookmark_recent_selector}`
    ).length
  )
    return;
  $(document).on(
    "change",
    "#jsDetailSearch .jsCheckAllZone .jsCheckALL",
    function () {
      const targetCheckBoxes = $(".jsCheckAllZone").find(
        `.${$(this).data("target-class")} input:checkbox`
      );
      checkAll(targetCheckBoxes, this);
    }
  );
});
/* ---------------------------------------------------------
 PC検索結果
 ※404、500でも使いまわす
--------------------------------------------------------- */
$(() => {
  if (
    !$(
      `body.pc.search.searchresult, body.pc.search.search_parallel_career, body.pc.search_for_company.show, ${pc_404_selector}, ${pc_500_selector}, ${bookmark_recent_selector}`
    ).length
  )
    return;
  // cookie -- 初めての時にのみ表示
  if (!Cookies.get("access")) {
    Cookies.set("access", "done", { expires: 200 });
    const insert_html =
      '<p class="favorite">気になる募集は<br>お気に入りで保存！</p>';
    $("#jsFirstAnnounce").html(insert_html);
  }

  // ヘルプアイコンにホバーしたときにtooltipを出す 参考: https://unguis.cre8or.jp/web/1934
  $(".jsTooltipHover").hover(
    function () {
      const text = $(this).data("text");
      $(this).append(`<div class="p_tooltip jsTooltip">${text}</div>`);
    },
    function () {
      $(this).find(".jsTooltip").remove();
    }
  );
});

$(() => {
  if (!$("body.pc.search.detail_search, body.pc.users.index").length) return;
  $("#jsDetailSearch").cleanQuery();
  $(document).on("click", '#jsDetailSearch input:not(".jsCheckALL")', () => {
    get_search_number();
  });
  // エリアモーダル部分クリックで選択中エリアが表示されるように
  $("#searchAreaModal")
    .find("input:checkbox")
    .change(function () {
      showCheckedItemName(this);
    });
  // 費用での絞り込み時の挙動
  $(document).on("change", "#jsMoneySelect", () => {
    changeMoneySelect();
    get_search_number();
  });

  // 期間、頻度、時間での絞り込み時の挙動
  $(document).on("change", "#jsTermDaysGteSelect", () => {
    changeSelectOf("Gte", "TermDays");
    // 「下限<=上限」となるようにoptionタグを非表示にする
    toggleDisplayOfLte("TermDays");
    get_search_number();
  });
  $(document).on("change", "#jsTermDaysLteSelect", () => {
    changeSelectOf("Lte", "TermDays");
    toggleDisplayOfGte("TermDays");
    get_search_number();
  });

  $(document).on("change", "#jsFrequentPerMonthGteSelect", () => {
    changeSelectOf("Gte", "FrequentPerMonth");
    toggleDisplayOfLte("FrequentPerMonth");
    get_search_number();
  });
  $(document).on("change", "#jsFrequentPerMonthLteSelect", () => {
    changeSelectOf("Lte", "FrequentPerMonth");
    toggleDisplayOfGte("FrequentPerMonth");
    get_search_number();
  });

  $(document).on("change", "#jsHoursPerWeekGteSelect", () => {
    changeSelectOf("Gte", "HoursPerWeek");
    toggleDisplayOfLte("HoursPerWeek");
    get_search_number();
  });
  $(document).on("change", "#jsHoursPerWeekLteSelect", () => {
    changeSelectOf("Lte", "HoursPerWeek");
    toggleDisplayOfGte("HoursPerWeek");
    get_search_number();
  });

  /// 活動日程変更時の検索駆動
  $(".datePicker").change(() => {
    get_search_number();
  });
  // モーダルの選択押したら件数表示
  $(document).on("click", ".jsModalSearch", () => {
    get_search_number();
  });
});
